import { languageOptions } from '../config/constants';
import CurrentUserResource from '../resources/Auth/CurrentUser';
import copy, { SingleLanguageCopyType } from '../assets/copy';

let copyByLanguage = (
  Object.keys(languageOptions) as (keyof typeof languageOptions)[]
).reduce(
  (acc, languageKey) => ({
    ...acc,
    [languageKey]: Object.entries(copy).reduce(
      (acc, [key, item]) => ({
        ...acc,
        [key]: item[languageKey],
      }),
      {},
    ),
  }),
  {},
) as Record<keyof typeof languageOptions, SingleLanguageCopyType>;

let useCopy = () => {
  let [currentUser] = CurrentUserResource.useLoadable();
  let languageKey =
    (currentUser?.prefersLanguageKey as keyof typeof languageOptions) ||
    languageOptions.english.key;

  return copyByLanguage[languageKey];
};

export default useCopy;
